<template>
    <div class="flex flex-col">
        <span class="mx-auto mt-32 pb-32" v-if="!subscription">
            <svg version="1.1" class="h-8 w-8 fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                </path>
            </svg>
        </span>

        <div class="relative z-0 w-full px-2 sm:px-10" v-else>
            <div class="absolute inset-x-0 top-0 z-0 bg-wecare-red" style="height: 400px;"></div>
            
            <div class="relative z-10 flex flex-col w-full mx-auto" style="max-width: 1200px">
                <span class="text-4xl font-bold text-white mt-6">Bonjour {{ subscription.firstname }}</span>
                <div class="flex flex-col bg-white border border-gray-600 sm:mb-6 mt-6 p-3 sm:p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <div class="flex flex-col items-center mx-auto w-full text-center leading-tight" style="max-width: 700px">
                        <img src="@/assets/img/nav/activation.svg" class="w-auto h-20" />

                        <span class="mt-2 text-4xl font-bold">Mon <span class="text-wecare-red">assurance</span></span>

                        <img src="@/assets/img/logo.svg" class="w-auto h-16 -mr-6"/>

                        <div class="flex flex-col items-center text-center w-full my-10 py-8 border-t border-b border-gray-500">
                            <span class="text-gray-700 font-medium text-lg">Mon numéro d’adhérent pour l'assurance WeCare</span>
                            <span class="text-4xl font-bold text-black mt-1" v-if="subscription.customer_number">{{ subscription.customer_number }}</span>
                            <span class="text-4xl font-bold text-black mt-1" v-else>{{ subscription.product_imei }}</span>
                        </div>

                        <div class="flex flex-col items-center text-center w-full mb-10 pb-8 border-b border-gray-500">
                            <span class="text-gray-700 font-medium text-lg">Mon assurance d’un an contre la casse</span>

                            <div class="flex w-full flex-col my-5 mx-auto" style="max-width: 550px" v-if="currentProgress <= 1">
                                <div class="h-10 bg-gray-200 rounded-full overflow-hidden w-full relative">
                                    <div class="absolute h-10 bg-wecare-red" :style="{'width': currentProgress.toFixed(2) * 100 + '%'}"></div>
                                </div>

                                <div class="flex justify-between mt-2 text-sm text-gray-700 font-medium">
                                    <span>{{ startingAt }}</span>
                                    <span>{{ endingAt }}</span>
                                </div>
                            </div>
                            
                            <span class="text-black text-2xl mt-3" v-else>Votre garantie est expirée</span>
                        </div>

                        <div class="flex flex-col items-center text-center w-full mb-10 pb-8 border-b border-gray-500">
                            <span class="text-gray-700 font-medium text-lg">Votre déclaration de sinistre</span>

                            <span class="text-4xl font-bold text-wecare-red mt-1" v-if="subscription.subscription_step">{{ subscription.subscription_step }}</span>
                            <span class="text-4xl font-bold text-wecare-red mt-1" v-else>Pas de sinistre</span>
                        </div>

                        <div class="flex flex-col items-center text-center w-full" v-if="currentProgress <= 1">
                            <span class="text-gray-700 font-medium text-lg">Vous avez cassé votre smartphone ?</span>
                            <router-link to="/claim" class="btn h-20 mt-3 cursor-pointer border border-wecare-red bg-wecare-red hover:scale-105 hover:bg-white hover:text-wecare-red">Déclarer un sinistre</router-link>
                        </div>
                    </div>
                </div>

                <div class="flex flex-col bg-white border border-gray-600 mb-12 mt-6 p-3 sm:p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <div class="flex flex-col items-center mx-auto w-full text-center leading-tight" style="max-width: 700px">
                        <img src="@/assets/img/smartphone.svg" class="h-24 w-auto mb-2" />
                        <span class="text-4xl font-bold mx-auto text-auto">Mon <span class="text-wecare-red"> smartphone</span></span>
                        <div class="my-5 border-t border-gray-500 w-full"></div>
                        <div class="w-full flex-col md:flex-row flex items-center">
                            <img :src="phoneImageUrl" class="w-auto h-64" />

                            <div class="flex flex-col text-left w-full">
                                <div class="flex flex-col w-full border-b border-gray-500 py-3">
                                    <span class="text-lg font-medium text-gray-700">Marque du smartphone</span>
                                    <span class="text-2xl font-bold">{{ subscription.product_mark }}</span>
                                </div>

                                <div class="flex flex-col w-full border-b border-gray-500 py-3">
                                    <span class="text-lg font-medium text-gray-700">Modèle du smartphone</span>
                                    <span class="text-2xl font-bold">{{ subscription.product_model }}</span>
                                </div>

                                <div class="flex flex-col w-full py-3">
                                    <span class="text-lg font-medium text-gray-700">Numéro d'IMEI de votre smartphone</span>
                                    <span class="text-2xl font-bold">{{ subscription.product_imei }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSubscription } from '@/auth'
const slugify = require('slugify')
const moment = require('moment')

export default {
    components: { },
    data: function () {
        return {
            subscription: null
        }
    },
    mounted: function () {
        getSubscription()
        .then(({data}) => {
            this.subscription = data
        }).catch(() => {
            window.sessionStorage.removeItem('access_token')
            this.$router.push('/login?session=expired')
        })
    },
    computed: {
        phoneImageUrl() {
            return '/phones/wecare-' + slugify(this.subscription.product_mark + '-' + this.subscription.product_model, {lower: true}) + '.jpg'
        },
        startingAt() {
            return moment(this.subscription.purchased_at).format('DD/MM/YYYY')
        },
        endingAt() {
            return moment(this.subscription.purchased_at).add(12, 'months').format('DD/MM/YYYY')
        },
        currentProgress() {
            return (moment().diff(moment(this.subscription.purchased_at), 'days') / 365)
        }
    }
}
</script>